import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getNewsletterSuccess, getNewsletterEmail } from 'Store/User/selectors';
import { fetchNewsletterSubscription } from 'Store/User/thunks';
import { getNewsLetterBanner, getSocialMediaBanner } from 'Store/Banners/selectors';
import BannerNewsAndSocialMedia, { Feedback } from 'Components/BannerNewsAndSocialMedia/BannerNewsAndSocialMedia';

interface IPropsInternal {
  newsletterSuccess: boolean;
  newsletterEmail: string;
  newsLetterContent: Julius.Content.Banner;
  socialMediaContent: Julius.Content.Banner;
  fetchNewsletterSubscription: (email: string) => void;
  setLoginEmail: (email: string) => void;
}

interface IState {
  emailInput: string;
  userFeedback: Feedback;
}

type Props = IPropsInternal;

class BannerNewsAndSocialMediaContainer extends React.PureComponent<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      emailInput: '',
      userFeedback: Feedback.NONE,
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const hideFeedback = 
      this.state.userFeedback !== Feedback.NONE &&
      nextProps.newsletterSuccess === this.props.newsletterSuccess;

    if (hideFeedback) {
      this.setState({ userFeedback: Feedback.NONE });
      return;
    }

    const showSuccess = nextProps.newsletterSuccess &&
      nextProps.newsletterEmail === this.state.emailInput;
    
    if (showSuccess) {
      this.setState({ userFeedback: Feedback.SUBSCRIPTION_SUCCESS });
      return;
    }

    const showError = !nextProps.newsletterSuccess &&
      nextProps.newsletterEmail === this.state.emailInput;

    if (showError) {
      this.setState({ userFeedback: Feedback.SUBSCRIPTION_FAILED });
    }
  }

  onEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ 
      emailInput: e.currentTarget.value, 
      userFeedback: Feedback.NONE,
    });
  }

  onSubscriptionSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (this.state.emailInput.length) {
      this.props.fetchNewsletterSubscription(this.state.emailInput);
    }
  }

  render() {
    return (
      <BannerNewsAndSocialMedia
        feedback={ this.state.userFeedback }
        urlFacebook='https://www.facebook.com/JuliusBiljettservice/'
        newsLetterContent={ this.props.newsLetterContent }
        socialMediaContent={ this.props.socialMediaContent }
        onEmailChange={ this.onEmailChange }
        onSubscriptionSubmit={ this.onSubscriptionSubmit }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    newsletterEmail: getNewsletterEmail(state),
    newsletterSuccess: getNewsletterSuccess(state),
    newsLetterContent: getNewsLetterBanner(state),
    socialMediaContent: getSocialMediaBanner(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchNewsletterSubscription,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(BannerNewsAndSocialMediaContainer);


// WEBPACK FOOTER //
// ./src/components/BannerNewsAndSocialMedia/BannerNewsAndSocialMediaContainer.tsx